import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelLarge} from "@khanacademy/wonder-blocks-typography";
import {doNotTranslateYet} from "@repo/i18n";
import {reload} from "@repo/urls";

type Props = {
    // Optionally, provide a navigation target for the CTA.
    // By default, we reload the current URL.
    href?: string;
};
/**
 * A component with a CTA to refresh the page to get access to Khanmigo.
 * This is used to encourage the user to refresh the page after they've
 * signed up or logged in via a different tab.
 */
export const RefreshForKhanmigo = ({href}: Props) => (
    <>
        <Strut size={spacing.large_24} />
        <LabelLarge>{doNotTranslateYet`Have Khanmigo access?`}</LabelLarge>
        <Strut size={spacing.large_24} />
        {href ? (
            <Button kind="secondary" href={href}>
                {doNotTranslateYet`Launch Khanmigo`}
            </Button>
        ) : (
            <Button kind="secondary" onClick={() => reload()}>
                {doNotTranslateYet`Launch Khanmigo`}
            </Button>
        )}
    </>
);
